import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import WkcApplyBuy from '@/types/table/wkcApplyBuy';
import ApplyBuyInfoDetailList from '@/types/table/applyBuyInfoDetailList';
import { ApplyBuyInfoData } from '@/api/generated/applyBuyInfoController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface WkcApplyBuyData extends WkcApplyBuy {
  applyBuyInfoList?: ApplyBuyInfoData[];
  __cascade_add_temp_id__?: string | number | undefined;
}

export type ApplyBuyInfoDetailListData = ApplyBuyInfoDetailList;

export default class WkcApplyBuyController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<WkcApplyBuyData>>(API_CONTEXT + '/app/wkcApplyBuy/list', params, httpOptions);
  }

  /** 采购计划明细报表（分页，按主表创建时间支持月/季度/半年/年筛选） */
  static detailInfoList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<ApplyBuyInfoDetailListData>>(
      API_CONTEXT + '/app/wkcApplyBuy/detailInfoList',
      params,
      httpOptions,
    );
  }

  /** 采购计划明细报表导出（与 detailInfoList 相同筛选；exportAll 为 true 导出全部） */
  static detailInfoListExport(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/wkcApplyBuy/detailInfoListExport', params, fileName);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<WkcApplyBuyData>(API_CONTEXT + '/app/wkcApplyBuy/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/wkcApplyBuy/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/wkcApplyBuy/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/wkcApplyBuy/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcApplyBuy/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcApplyBuy/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcApplyBuy/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcApplyBuy/deleteBatch', params, httpOptions);
  }
  static startOnlyApplyBuy(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcApplyBuy/startOnly/applyBuy', params, httpOptions);
  }
  static startWithBusinessKeyApplyBuy(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcApplyBuy/startWithBusinessKey/applyBuy', params, httpOptions);
  }
  static startAndTakeUserTaskApplyBuy(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcApplyBuy/startAndTakeUserTask/applyBuy', params, {
      throttleFlag: true,
      throttleTimeout: 5000,
      ...httpOptions,
    });
  }
  static startAndSaveDraftApplyBuy(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcApplyBuy/startAndSaveDraft/applyBuy', params, httpOptions);
  }
  static submitUserTaskApplyBuy(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcApplyBuy/submitUserTask/applyBuy', params, {
      throttleFlag: true,
      throttleTimeout: 5000,
      ...httpOptions,
    });
  }
  static viewTaskBusinessDataApplyBuy(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/wkcApplyBuy/viewTaskBusinessData/applyBuy', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataApplyBuy(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/wkcApplyBuy/viewHistoricTaskBusinessData/applyBuy', params, httpOptions);
  }
  static listWorkOrderApplyBuy(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcApplyBuy/listWorkOrder/applyBuy', params, httpOptions);
  }

  static saveWkcPurchase(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPurchase/saveWkcPurchase', params, httpOptions);
  }

  static getDeptList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dept/getDept', params, httpOptions);
  }
  static deleteMessage(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dept/deleteMessage', params, httpOptions);
  }

}
